import Parse from "parse";
import debug from "src/modules/debug-logger";

export async function registerXmppDevice(deviceName) {
  const device = await Parse.Cloud.run("registerXmppDevice", {
    deviceType: 9,
    deviceName
  });
  debug.device("New XMPP device registered.", device);

  const xmppLogin = device.username;
  const xmppPassword = device.password;

  window.localStorage.setItem("xmppLogin", xmppLogin);
  window.localStorage.setItem("xmppPassword", xmppPassword);

  return {
    xmppLogin: device.username,
    xmppPassword: device.password
  };
}

export function removeDeviceFromFamily({ xmppLogin, password }) {
  return Parse.Cloud.run("removeDeviceFromFamily", { xmppLogin, password });
}

export function unpairDevice({ xmppLogin }) {
  return Parse.Cloud.run("unpairDevice", { xmppLogin });
}

export function setDeviceName({ xmppLogin, deviceName }) {
  return Parse.Cloud.run("setDeviceName", { xmppLogin, deviceName });
}

export function getDevices() {
  return Parse.Cloud.run("getDevices");
}
